import { F64 } from '../engine/typed-arrays.js';

const MAT4_STORAGE_F64_BUILD_TAG = "@@MAT4_STORAGE_F64@@";
function allocateF64Mat4() {
  return new F64(16);
}
allocateF64Mat4[MAT4_STORAGE_F64_BUILD_TAG] = true;

export { MAT4_STORAGE_F64_BUILD_TAG, allocateF64Mat4 };
//# sourceMappingURL=_mat4-storage-f64.js.map
